import React from "react";
import * as BackEndConsts from "tools/constants/backEndConstants";
import { dataService } from "tools/dataService/dataService"
import { trackPromise } from "react-promise-tracker";
import ThemeContext from "contexts/ThemeContext";
import {
  platformNotifMessages,
  handleInputChange,
  handleChangeDropdown,
  CustomField,
  debugLog
} from "tools/commonFunctions";
import { LainoSwitch } from "components/Switch/Switch";
import FormModal from "components/Modal/FormModal";
import { areConfigValuesEqual } from "tools/keyValueConfig";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import {
  Col,
  Row,
  Button,
  Label,
  Collapse
} from "reactstrap";

import { Formik, Form } from 'formik';
import * as Yup from 'yup';

class AppComponent extends React.Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      appId: this.props.appId,
      componentId: (this.props.appComponent && this.props.appComponent.id) ? this.props.appComponent.id : null,
      componentName: this.props.appComponent && this.props.appComponent.publicname ? this.props.appComponent.publicname : "",
      componentVersion: this.props.appComponent && this.props.appComponent.imageversion ? this.props.appComponent.imageversion : "",
      componentUpgradeVersion: this.props.appComponent && this.props.appComponent.imageversion_toupgrade ? this.props.appComponent.imageversion_toupgrade : "",
      componentLabelId: (this.props.appComponent && this.props.appComponent.k8label && this.props.appComponent.k8label.id) ? this.props.appComponent.k8label.id : null,
      componentLabelName: (this.props.appComponent && this.props.appComponent.k8label && this.props.appComponent.k8label.name) ? this.props.appComponent.k8label.name : null,
      componentStorageName: (this.props.appComponent && this.props.appComponent.k8storage && this.props.appComponent.k8storage.publicname) ? this.props.appComponent.k8storage.publicname : null,
      componentStorageId: (this.props.appComponent && this.props.appComponent.k8storage && this.props.appComponent.k8storage.id) ? this.props.appComponent.k8storage.id : null,
      showComponentPods: this.props.appComponent && this.props.appComponent.showpodsnumber ? this.props.appComponent.showpodsnumber : false,
      showLoadBalancer: this.props.appComponent && this.props.appComponent.showloadbalancer ? this.props.appComponent.showloadbalancer : false,
      showResourceParams: this.props.appComponent && this.props.appComponent.showhwresources ? this.props.appComponent.showhwresources : false,
      componentPods: this.props.appComponent && this.props.appComponent.podsnumber ? this.props.appComponent.podsnumber : 0,
      componentMinimumPods: this.props.appComponent && this.props.appComponent.lowerlimitpods ? this.props.appComponent.lowerlimitpods : 0,
      componentQuorumPods: this.props.appComponent && this.props.appComponent.quorumpods ? this.props.appComponent.quorumpods : false,
      loadbalancer: this.props.appComponent && this.props.appComponent.loadbalancer ? this.props.appComponent.loadbalancer : false,
      componentCPU: parseInt(this.props.appComponent && this.props.appComponent.cpureq ? this.props.appComponent.cpureq : 0),
      componentMinCPU: parseInt(this.props.appComponent && this.props.appComponent.cpureq_default ? this.props.appComponent.cpureq_default : 0),
      componentCPULimit: parseInt(this.props.appComponent && this.props.appComponent.cpulimit ? this.props.appComponent.cpulimit : 0),
      componentMem: parseInt(this.props.appComponent && this.props.appComponent.memreq ? this.props.appComponent.memreq : 0),
      componentMinMem: parseInt(this.props.appComponent && this.props.appComponent.memreq_default ? this.props.appComponent.memreq_default : 0),
      componentMemLimit: parseInt(this.props.appComponent && this.props.appComponent.memlimit ? this.props.appComponent.memlimit : 0),
      appFinishedState: this.props.appFinishedState,
      deployButtonDisable: this.props.deployButtonDisable,
      isModalAuxBtnDisabled: false,
      componentProtocolId: this.props.componentProtocolId,
      componentProtocols: this.props.componentProtocols || [],
      filteredComponentProtocols: (this.props.componentProtocols || []).map((protocol) => {
        //Object Destructuring--> removes the field "name" from the object since the mutation only allows fields "id" and "enabled"
        const { name, ...newObj } = protocol;
        return newObj
      }),
      componentEnabledProtocols: this.props.componentEnabledProtocols || [],
      componentPersistences: (this.props.appComponent && this.props.appComponent.appcomponentpersistences) ? this.props.appComponent.appcomponentpersistences : [],
      componentConfiguration: (this.props.appComponent && this.props.appComponent.appcomponentconfigs) ? this.props.appComponent.appcomponentconfigs : [],
      componentSecrets: (this.props.appComponent && this.props.appComponent.appcomponentsecrets) ? this.props.appComponent.appcomponentsecrets : [],
      componentStateChange: false,
      accordionOpened: false,
      modalTitleText: "",
      modalBodyText: "",
      modalAcceptBtn: "",
      modalCancelBtn: "",
      isDirty: false // Track form dirty state for batch editing
    }

    // After a rolled back deployment the user can choose to keep the values that
    // failed to deploy. They are applied on top of the server data so the form
    // reopens dirty and the whole configuration does not have to be redone.
    Object.assign(this.state, this.buildPendingValuesOverlay(props));

    this.lastNotifiedValuesStr = '';
    this.lastNotifiedParentDirty = false;
  };

  buildPendingValuesOverlay(props) {
    const pending = props.pendingValues;
    if (!pending) return {};

    const overlay = {
      componentPods: pending.componentPods,
      componentCPU: pending.componentCPU,
      componentCPULimit: pending.componentCPULimit,
      componentMem: pending.componentMem,
      componentMemLimit: pending.componentMemLimit,
      loadbalancer: Boolean(pending.loadbalancerSwitch)
    };

    if (pending.componentLabelId) {
      overlay.componentLabelId = pending.componentLabelId;
      const label = (props.platformLabels || []).find(
        (l) => String(l.id) === String(pending.componentLabelId)
      );
      if (label) overlay.componentLabelName = label.name;
    }

    if (Array.isArray(pending.filteredComponentProtocols)) {
      overlay.filteredComponentProtocols = pending.filteredComponentProtocols;
      overlay.componentEnabledProtocols = pending.filteredComponentProtocols
        .filter((p) => p.enabled)
        .map((p) => p.id);
    }

    if (Array.isArray(pending.componentConfiguration)) {
      overlay.componentConfiguration = pending.componentConfiguration;
    }
    if (Array.isArray(pending.componentSecrets)) {
      overlay.componentSecrets = pending.componentSecrets;
    }

    return overlay;
  }

  buildConfigMergedArray(appComponent) {
    const t = this.props.i18n.t;
    const compoConfigMerged = [];

    if (appComponent && appComponent.appcomponentconfigs && appComponent.appcomponentconfigs.length > 0) {
      appComponent.appcomponentconfigs.forEach((componentConfig) => {
        compoConfigMerged.push(componentConfig);
      });
    }

    if (appComponent && appComponent.appcomponentsecrets && appComponent.appcomponentsecrets.length > 0) {
      appComponent.appcomponentsecrets.forEach((componentSecret) => {
        if (componentSecret.type !== "AUTO") {
          compoConfigMerged.push({
            configtype: "SECRET",
            defaultvalue: componentSecret.value,
            description: t("platformService.serviceApp.appComponent.thisSecret"),
            format: "STRING",
            id: componentSecret.id,
            publicname: componentSecret.name,
            showdefault: true,
            value: componentSecret.value,
          });
        }
      });
    }

    return compoConfigMerged;
  }

  syncStateFromAppComponent(appComponent) {
    return {
      componentId: (appComponent && appComponent.id) ? appComponent.id : null,
      componentName: appComponent && appComponent.publicname ? appComponent.publicname : "",
      showComponentPods: appComponent && appComponent.showpodsnumber ? appComponent.showpodsnumber : false,
      showLoadBalancer: appComponent && appComponent.showloadbalancer ? appComponent.showloadbalancer : false,
      showResourceParams: appComponent && appComponent.showhwresources ? appComponent.showhwresources : false,
      componentPods: appComponent && appComponent.podsnumber ? appComponent.podsnumber : 0,
      componentMinimumPods: appComponent && appComponent.lowerlimitpods ? appComponent.lowerlimitpods : 0,
      componentQuorumPods: appComponent && appComponent.quorumpods ? appComponent.quorumpods : false,
      loadbalancer: appComponent && appComponent.loadbalancer ? appComponent.loadbalancer : false,
      componentCPU: parseInt(appComponent && appComponent.cpureq ? appComponent.cpureq : 0, 10),
      componentMinCPU: parseInt(appComponent && appComponent.cpureq_default ? appComponent.cpureq_default : 0, 10),
      componentCPULimit: parseInt(appComponent && appComponent.cpulimit ? appComponent.cpulimit : 0, 10),
      componentMem: parseInt(appComponent && appComponent.memreq ? appComponent.memreq : 0, 10),
      componentMinMem: parseInt(appComponent && appComponent.memreq_default ? appComponent.memreq_default : 0, 10),
      componentMemLimit: parseInt(appComponent && appComponent.memlimit ? appComponent.memlimit : 0, 10),
      componentStorageId: (appComponent && appComponent.k8storage && appComponent.k8storage.id) ? appComponent.k8storage.id : null,
      componentStorageName: (appComponent && appComponent.k8storage && appComponent.k8storage.publicname) ? appComponent.k8storage.publicname : null,
      componentPersistences: (appComponent && appComponent.appcomponentpersistences) ? appComponent.appcomponentpersistences : [],
      componentConfiguration: (appComponent && appComponent.appcomponentconfigs) ? appComponent.appcomponentconfigs : [],
      componentSecrets: (appComponent && appComponent.appcomponentsecrets) ? appComponent.appcomponentsecrets : [],
      componentConfigMergedArray: this.buildConfigMergedArray(appComponent),
      isDirty: false
    };
  }

  componentDidMount() {
    const compoConfigMerged = this.buildConfigMergedArray(this.props.appComponent);

    this.setState({
      componentConfigMergedArray: compoConfigMerged,
      [compoConfigMerged.publicname + '-confModal']: false,
      [compoConfigMerged.publicname + '-Id']: compoConfigMerged.id,
      [compoConfigMerged.publicname + '-Value']: compoConfigMerged.value
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const rolledBackNow = this.props.appDeployCode === BackEndConsts.DEPLOYMENT_STATE_ROLLEDBACK
      && prevProps.appDeployCode !== BackEndConsts.DEPLOYMENT_STATE_ROLLEDBACK;

    if (this.props.componentUpdated !== prevProps.componentUpdated ||
        this.props.appComponent !== prevProps.appComponent ||
        this.props.appId !== prevProps.appId ||
        rolledBackNow) {
      this.setState({
        appId: this.props.appId,
        appFinishedState: this.props.appFinishedState,
        componentProtocolId: this.props.componentProtocolId,
        deployButtonDisable: this.props.deployButtonDisable,
        ...this.syncStateFromAppComponent(this.props.appComponent),
        ...this.buildPendingValuesOverlay(this.props)
      });
    }
  }

  openConfigModalFromLocalEntry = (componentParameterName, entry, t) => {
    if (!entry || !entry.publicname) {
      return false;
    }

    this.setState({
      [componentParameterName]: !this.state[componentParameterName],
      activeComponentConfigId: entry.id,
      activeComponentConfigName: entry.publicname + '-confModal',
      activeComponentConfigLabel: entry.publicname,
      activeComponentConfigValue: entry.value != null ? String(entry.value) : "",
      activeComponentConfigDefValue: entry.defaultvalue,
      activeComponentConfigModalType: entry.configtype,
      activeComponentConfigModalFormat: entry.format,
      activeComponentConfigBodyText: entry.description,
      activeComponentConfigShowAuxBtn: entry.showdefault,
      activeComponentConfigAcceptBtn: t("common.save"),
      activeComponentConfigCancelBtn: t("common.exit"),
      activeComponentConfigAuxBtn: t("platformService.serviceApp.appComponent.setDefault"),
      isModalAuxBtnDisabled: false
    });
    return true;
  }

  openSecretModalFromLocalEntry = (componentParameterName, entry, t) => {
    if (!entry || !entry.name) {
      return false;
    }

    this.setState({
      [componentParameterName]: !this.state[componentParameterName],
      activeComponentConfigId: entry.id,
      activeComponentConfigName: entry.name + '-confModal',
      activeComponentConfigLabel: entry.name,
      activeComponentConfigValue: entry.value != null ? String(entry.value) : "",
      activeComponentConfigDefValue: entry.value,
      activeComponentConfigModalType: "SECRET",
      activeComponentConfigModalFormat: "STRING",
      activeComponentConfigBodyText: t("platformService.serviceApp.appComponent.thisSecret"),
      activeComponentConfigAcceptBtn: t("common.save"),
      activeComponentConfigCancelBtn: t("common.exit"),
      activeComponentConfigAuxBtn: t("platformService.serviceApp.appComponent.setDefault"),
      isModalAuxBtnDisabled: false
    });
    return true;
  }

  getConfigData(componentParameterId, componentParameterName) {
    const t = this.props.i18n.t;

    if (componentParameterId.length > 0) { //If clause to call the query just when it makes sense
      const pendingConfig = (this.state.componentConfiguration || []).find(
        (c) => c && String(c.id) === String(componentParameterId) && c.isDirty
      );

      // Unsaved edits live only in local state until the card Save runs.
      // Reopening the modal must show that pending value, not the server snapshot.
      if (pendingConfig && this.openConfigModalFromLocalEntry(componentParameterName, pendingConfig, t)) {
        return;
      }

      trackPromise(
        dataService.queries.getAppComponentConfiguration(
          componentParameterId
        ).then(
          (datacompconfig) => {
            if (datacompconfig !== BackEndConsts.BACKEND_RESPONSE_ERROR &&
              datacompconfig.config.publicname) {
              const pendingAfterFetch = (this.state.componentConfiguration || []).find(
                (c) => c && String(c.id) === String(componentParameterId) && c.isDirty
              );
              const displayValue = pendingAfterFetch
                ? (pendingAfterFetch.value != null ? String(pendingAfterFetch.value) : "")
                : datacompconfig.config.value;

              return (
                this.setState({
                  [componentParameterName]: !this.state[componentParameterName], //State to SHOW/Hide the modal
                  activeComponentConfigId: datacompconfig.config.id,
                  activeComponentConfigName: datacompconfig.config.publicname + '-confModal',
                  activeComponentConfigLabel: datacompconfig.config.publicname,
                  activeComponentConfigValue: displayValue,
                  activeComponentConfigDefValue: datacompconfig.config.defaultvalue,
                  activeComponentConfigModalType: datacompconfig.config.configtype,
                  activeComponentConfigModalFormat: datacompconfig.config.format,
                  activeComponentConfigBodyText: datacompconfig.config.description,
                  activeComponentConfigShowAuxBtn: datacompconfig.config.showdefault,
                  activeComponentConfigAcceptBtn: t("common.save"),
                  activeComponentConfigCancelBtn: t("common.exit"),
                  activeComponentConfigAuxBtn: t("platformService.serviceApp.appComponent.setDefault"),
                  isModalAuxBtnDisabled: false
                })
              )
            }
          }
        )
      )
    } else {
      this.setState({
        [componentParameterName + '-confModal']: !this.state[componentParameterName + '-confModal'],
      });
    }
  }

  getSecretData(componentParameterId, componentParameterName) {
    const t = this.props.i18n.t;

    if (componentParameterId.length > 0) { //If clause to call the query just when it makes sense
      const pendingSecret = (this.state.componentSecrets || []).find(
        (s) => s && String(s.id) === String(componentParameterId) && s.isDirty
      );

      if (pendingSecret && this.openSecretModalFromLocalEntry(componentParameterName, pendingSecret, t)) {
        return;
      }

      trackPromise(
        dataService.queries.getAppComponentSecretConfiguration(
          componentParameterId
        ).then(
          (datacompsecretconfig) => {
            if (datacompsecretconfig !== BackEndConsts.BACKEND_RESPONSE_ERROR &&
              datacompsecretconfig.secret.name) {
              const pendingAfterFetch = (this.state.componentSecrets || []).find(
                (s) => s && String(s.id) === String(componentParameterId) && s.isDirty
              );
              const displayValue = pendingAfterFetch
                ? (pendingAfterFetch.value != null ? String(pendingAfterFetch.value) : "")
                : datacompsecretconfig.secret.value;

              return (
                this.setState({
                  [componentParameterName]: !this.state[componentParameterName], //State to SHOW/Hide the modal
                  activeComponentConfigId: datacompsecretconfig.secret.id,
                  activeComponentConfigName: datacompsecretconfig.secret.name + '-confModal',
                  activeComponentConfigLabel: datacompsecretconfig.secret.name,
                  activeComponentConfigValue: displayValue,
                  activeComponentConfigDefValue: datacompsecretconfig.secret.value,
                  activeComponentConfigModalType: "SECRET",
                  activeComponentConfigModalFormat: "STRING",
                  activeComponentConfigBodyText: t("platformService.serviceApp.appComponent.thisSecret"),
                  activeComponentConfigAcceptBtn: t("common.save"),
                  activeComponentConfigCancelBtn: t("common.exit"),
                  activeComponentConfigAuxBtn: t("platformService.serviceApp.appComponent.setDefault"),
                  isModalAuxBtnDisabled: false
                })
              )
            }
          }
        )
      )
    } else (
      this.setState({
        [componentParameterName]: !this.state[componentParameterName], //State to SHOW/Hide the modal
      })
    )
  }

  updateData = (values, formikHelpers) => {
    if (this.props.appActivation === true) return;

    if (!values.componentLabelId || String(values.componentLabelId).trim() === "") {
      if (formikHelpers && typeof formikHelpers.setFieldTouched === "function") {
        formikHelpers.setFieldTouched("componentLabel", true, true);
      }
      platformNotifMessages(
        "DANGER",
        this.props.i18n.t("common.error"),
        this.props.i18n.t("platformService.serviceApp.appComponent.labelDropdown.errorMessage"),
        this.state.componentName
      );
      return;
    }
    const persistenceData = values.componentPersistences.map((filteredPersistence) => {
      const sizeAsString = String(filteredPersistence.size);
      const sizeWithUnit = sizeAsString.endsWith('Gi')
        ? filteredPersistence.size
        : `${filteredPersistence.size}Gi`; //Concat of 'Gi' string since it's what Backend understands
      return {
        idpersistence: filteredPersistence.id,
        idstorage: (filteredPersistence.k8storage && filteredPersistence.k8storage.id) ? filteredPersistence.k8storage.id : (this.state.componentStorageId || ""),
        size: sizeWithUnit
      };
    });

    // Ensure no null values in idstorage
    persistenceData.forEach(p => {
      if (p.idstorage === null || p.idstorage === undefined) {
        p.idstorage = "";
      }
    });

    // For non-deployed apps, individual parameter (config) and secret edits are
    // only kept in local state until Save. Besides the infra update we must also
    // persist those pending changes through their dedicated mutations; otherwise
    // they are silently discarded (they are not part of updateAppComponent).
    const dirtyConfigs = (this.state.componentConfiguration || []).filter(c => c && c.isDirty);
    const dirtySecrets = (this.state.componentSecrets || []).filter(s => s && s.isDirty);

    const toStringValue = (val) => (val === null || val === undefined) ? "" : String(val);

    const infraUpdatePromise = dataService.mutations.updateAppComponent(
      this.state.componentId,
      this.state.appId,
      values.componentPods,
      values.loadbalancerSwitch,
      values.componentCPU,
      values.componentCPULimit,
      values.componentMem,
      values.componentMemLimit,
      values.componentLabelId,
      this.state.filteredComponentProtocols,
      persistenceData
    );

    const configUpdatePromises = dirtyConfigs.map(c =>
      dataService.mutations.updateAppComponentConfig(c.id, toStringValue(c.value))
    );
    const secretUpdatePromises = dirtySecrets.map(s =>
      dataService.mutations.updateAppComponentSecret(s.id, toStringValue(s.value))
    );

    trackPromise(
      Promise.all([infraUpdatePromise, ...configUpdatePromises, ...secretUpdatePromises]).then(
        (results) => {
          const dataupdatecomp = results[0];

          // Infra update is the anchor: if it failed the error was already surfaced.
          if (dataupdatecomp === BackEndConsts.BACKEND_RESPONSE_ERROR || !dataupdatecomp) {
            return;
          }

          // A failed param mutation keeps the component dirty so the user can retry.
          const paramResults = results.slice(1);
          const anyParamFailed = paramResults.some(
            r => r === BackEndConsts.BACKEND_RESPONSE_ERROR || !r
          );

          platformNotifMessages(
            dataupdatecomp.response.messageinfo.messagelevel,
            dataupdatecomp.response.messageinfo.messagetitle,
            dataupdatecomp.response.messageinfo.message,
            this.state.componentName)

          const resetForm = formikHelpers && typeof formikHelpers.resetForm === "function"
            ? formikHelpers.resetForm
            : null;

          // Clear dirty flags on persisted params only when every one succeeded.
          const clearedConfigs = (this.state.componentConfiguration || []).map(
            c => (c && c.isDirty) ? { ...c, isDirty: false } : c
          );
          const clearedSecrets = (this.state.componentSecrets || []).map(
            s => (s && s.isDirty) ? { ...s, isDirty: false } : s
          );

          this.setState({
            componentPods: values.componentPods,
            componentCPU: values.componentCPU,
            componentCPULimit: values.componentCPULimit,
            componentMem: values.componentMem,
            componentMemLimit: values.componentMemLimit,
            componentLabelName: values.componentLabel,
            componentLabelId: values.componentLabelId,
            componentEnabledProtocols: values.enabledProtocols,
            loadbalancer: values.loadbalancerSwitch,
            componentPersistences: values.componentPersistences,
            componentConfiguration: anyParamFailed ? this.state.componentConfiguration : clearedConfigs,
            componentSecrets: anyParamFailed ? this.state.componentSecrets : clearedSecrets,
            isDirty: anyParamFailed
          }, () => {
            if (!anyParamFailed && resetForm) {
              resetForm({ values });
            }
          });

          if (!anyParamFailed) {
            this.notifyDirtyStateChange(false);
          }

          if (dataupdatecomp.response.messageinfo.messagecode === BackEndConsts.DEPLOYMENT_STATE_UPDATING) {
            //Call to refresh deployment data every X seconds until state not being UPDATING
            this.props.requestDeployLoop("UPDATING", this.state.appId, 5000)
          }
        }
      )
    )
  }

  handleDiscard = (resetForm) => {
    resetForm();

    const originalProtocols = (this.props.componentProtocols || []).map((protocol) => {
      const { name, ...newObj } = protocol;
      return newObj
    });

    const originalConfigs = (this.props.appComponent && this.props.appComponent.appcomponentconfigs) ? this.props.appComponent.appcomponentconfigs : [];
    const originalSecrets = (this.props.appComponent && this.props.appComponent.appcomponentsecrets) ? this.props.appComponent.appcomponentsecrets : [];

    this.setState({
      filteredComponentProtocols: originalProtocols,
      componentConfiguration: originalConfigs,
      componentSecrets: originalSecrets,
      isDirty: false
    });

    this.lastNotifiedValuesStr = '';
    this.lastNotifiedParentDirty = false;
    this.notifyDirtyStateChange(false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.batchValidationCounter !== prevProps.batchValidationCounter) {
      const formikProps = this.currentFormikProps;
      if (formikProps) {
        const labelId = formikProps.values && formikProps.values.componentLabelId;
        if (!labelId && typeof formikProps.setFieldTouched === "function") {
          formikProps.setFieldTouched("componentLabel", true, true);
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.dirtyCheckTimeout) {
      clearTimeout(this.dirtyCheckTimeout);
    }
  }

  // Synchronously validate the given values against the dynamic Yup schema and
  // return both the overall validity and a per-field error map (field -> message).
  // This is used instead of Formik's `isValid`, which lags one render behind the
  // values and cannot expose the individual field messages the batch modal needs.
  computeValidation = (values) => {
    try {
      this.createDynamicYupSchema().validateSync(values, { abortEarly: false });
      return { isValid: true, errors: {} };
    } catch (err) {
      const errors = {};
      if (err && Array.isArray(err.inner) && err.inner.length > 0) {
        err.inner.forEach((innerError) => {
          if (innerError && innerError.path && !errors[innerError.path]) {
            errors[innerError.path] = innerError.message;
          }
        });
      } else if (err && err.path) {
        errors[err.path] = err.message;
      }
      return { isValid: false, errors };
    }
  }

  normalizeResourceValue = (val, type) => {
    if (val === null || val === undefined) return type === 'bool' ? false : 0;
    if (type === 'bool') return val === true || val === 'true';
    const strVal = String(val);
    if (type === 'cpu') return parseInt(strVal.replace('m', ''), 10) || 0;
    if (type === 'mem') return parseInt(strVal.replace('Mi', ''), 10) || 0;
    return val;
  }

  // For deployed apps, compare against server baseline — Formik `dirty` can stay true
  // after the user reverts a field to its original value.
  hasFormValueChanges = (values) => {
    const original = this.props.appComponent;
    if (!original || !values) return false;

    if (Number(values.componentPods) !== Number(original.podsnumber || 0)) return true;
    if (this.normalizeResourceValue(values.componentCPU, 'cpu') !== this.normalizeResourceValue(original.cpureq, 'cpu')) return true;
    if (this.normalizeResourceValue(values.componentCPULimit, 'cpu') !== this.normalizeResourceValue(original.cpulimit, 'cpu')) return true;
    if (this.normalizeResourceValue(values.componentMem, 'mem') !== this.normalizeResourceValue(original.memreq, 'mem')) return true;
    if (this.normalizeResourceValue(values.componentMemLimit, 'mem') !== this.normalizeResourceValue(original.memlimit, 'mem')) return true;
    if (Boolean(values.loadbalancerSwitch) !== Boolean(original.loadbalancer)) return true;

    const originalLabelId = original.k8label ? original.k8label.id : null;
    if (String(values.componentLabelId || '') !== String(originalLabelId || '')) return true;

    const originalEnabled = (original.appcomponentprotocols || [])
      .filter((p) => p.enabled)
      .map((p) => String(p.id))
      .sort();
    const currentEnabled = (values.enabledProtocols || []).map(String).sort();
    if (JSON.stringify(originalEnabled) !== JSON.stringify(currentEnabled)) return true;

    const origPersistences = original.appcomponentpersistences || [];
    const curPersistences = values.componentPersistences || [];
    for (let i = 0; i < origPersistences.length; i++) {
      const op = origPersistences[i];
      const cp = curPersistences.find((p) => String(p.id) === String(op.id)) || curPersistences[i];
      if (!cp) continue;
      const origSize = parseInt(String(op.size || '').replace('Gi', ''), 10) || 0;
      const curSize = parseInt(String(cp.size || '').replace('Gi', ''), 10) || 0;
      if (origSize !== curSize) return true;
      const origStorageId = op.k8storage && op.k8storage.id ? String(op.k8storage.id) : '';
      const curStorageId = cp.k8storage && cp.k8storage.id ? String(cp.k8storage.id) : '';
      if (origStorageId !== curStorageId) return true;
    }

    return false;
  }

  syncConfigSecretDirtyFlags = () => {
    const original = this.props.appComponent;
    if (!original) {
      return { componentConfiguration: this.state.componentConfiguration, componentSecrets: this.state.componentSecrets };
    }

    const componentConfiguration = (this.state.componentConfiguration || []).map((c) => {
      if (!c || !c.isDirty) return c;
      const orig = (original.appcomponentconfigs || []).find((o) => String(o.id) === String(c.id));
      const configType = c.configtype || (orig && orig.configtype);
      const matches = areConfigValuesEqual(orig ? orig.value : "", c.value, configType);
      return matches ? { ...c, isDirty: false } : c;
    });

    const componentSecrets = (this.state.componentSecrets || []).map((s) => {
      if (!s || !s.isDirty) return s;
      const orig = (original.appcomponentsecrets || []).find((o) => String(o.id) === String(s.id));
      const matches = String(s.value ?? '') === String(orig ? (orig.value ?? '') : '');
      return matches ? { ...s, isDirty: false } : s;
    });

    return { componentConfiguration, componentSecrets };
  }

  // Notify parent component when dirty state changes
  notifyDirtyStateChange = (isDirty, values = null, isValid = true, validationErrors = {}) => {
    // Only notify if parent provided the callback
    if (this.props.onDirtyStateChange && typeof this.props.onDirtyStateChange === 'function') {
      let mutationData = null;
      if (isDirty && values && this.props.appActivation === true) {
        mutationData = this.prepareMutationData(values);
      }

      this.props.onDirtyStateChange(
        this.state.componentId,
        this.state.componentName,
        isDirty,
        mutationData,
        isValid,
        validationErrors
      );
    }
  }

  hasDirtyConfigOrSecretChanges = () => {
    const original = this.props.appComponent;
    if (!original) return false;

    const configChanged = (this.state.componentConfiguration || []).some((c) => {
      if (!c) return false;
      const orig = (original.appcomponentconfigs || []).find((o) => String(o.id) === String(c.id));
      const configType = c.configtype || (orig && orig.configtype);
      return !areConfigValuesEqual(orig ? orig.value : "", c.value, configType);
    });

    const secretChanged = (this.state.componentSecrets || []).some((s) => {
      if (!s) return false;
      const orig = (original.appcomponentsecrets || []).find((o) => String(o.id) === String(s.id));
      return String(s.value ?? '') !== String(orig ? (orig.value ?? '') : '');
    });

    return configChanged || secretChanged;
  }

  prepareMutationData = (values) => {
    const persistenceData = values.componentPersistences.map((filteredPersistence) => {
      const sizeAsString = String(filteredPersistence.size);
      const sizeWithUnit = sizeAsString.endsWith('Gi')
        ? filteredPersistence.size
        : `${filteredPersistence.size}Gi`; //Concat of 'Gi' string since it's what Backend understands
      return {
        idpersistence: filteredPersistence.id,
        idstorage: (filteredPersistence.k8storage && filteredPersistence.k8storage.id) ? filteredPersistence.k8storage.id : (this.state.componentStorageId || ""),
        size: sizeWithUnit
      };
    });

    // Ensure no null values in idstorage
    persistenceData.forEach(p => {
      if (p.idstorage === null || p.idstorage === undefined) {
        p.idstorage = "";
      }
    });

    const protocolsData = this.state.componentProtocols.map(p => ({
      id: p.id,
      enabled: values.enabledProtocols.includes(p.id)
    }));

    return {
      componentPods: values.componentPods,
      loadbalancerSwitch: values.loadbalancerSwitch,
      componentCPU: values.componentCPU,
      componentCPULimit: values.componentCPULimit,
      componentMem: values.componentMem,
      componentMemLimit: values.componentMemLimit,
      componentLabelId: values.componentLabelId,
      filteredComponentProtocols: protocolsData,
      persistenceData: persistenceData,
      componentConfiguration: this.state.componentConfiguration,
      componentSecrets: this.state.componentSecrets
    };
  }

  updateComponentConfigData(e) {
    this.toggleModal(e);

    const nextValue = e && e.value !== undefined && e.value !== null
      ? String(e.value)
      : (this.state.activeComponentConfigValue === null || this.state.activeComponentConfigValue === undefined
        ? ""
        : String(this.state.activeComponentConfigValue));

    const newConfigs = this.state.componentConfiguration.map(c => {
      if (c.id === this.state.activeComponentConfigId) {
        return { ...c, value: nextValue, isDirty: true };
      }
      return c;
    });

    this.setState({
      componentConfiguration: newConfigs,
      isDirty: true
    }, () => {
      this.notifyDirtyStateChange(true, this.currentFormikValues || {});
    });
  }

  updateComponentSecretData(e) {
    this.toggleModal(e);

    const nextValue = e && e.value !== undefined && e.value !== null
      ? String(e.value)
      : (this.state.activeComponentConfigValue === null || this.state.activeComponentConfigValue === undefined
        ? ""
        : String(this.state.activeComponentConfigValue));

    const newSecrets = this.state.componentSecrets.map(s => {
      if (s.id === this.state.activeComponentConfigId) {
        return { ...s, value: nextValue, isDirty: true };
      }
      return s;
    });

    this.setState({
      componentSecrets: newSecrets,
      isDirty: true
    }, () => {
      this.notifyDirtyStateChange(true, this.currentFormikValues || {});
    });
  }

  handleInputChangeLoc = (e, setFieldValue) => {
    let inputResponse = handleInputChange(e);

    if (inputResponse.id.startsWith('persistence-')) {
      const [_, index, , fieldName] = inputResponse.name.split('-');
      if (fieldName === "size") {
        // Numeric value saved in the formulary
        const numericValue = parseInt(inputResponse.value.replace('Gi', ''), 10);
        if (!isNaN(numericValue)) {
          setFieldValue(`componentPersistences[${index}].size`, numericValue);
        };
      }
    } else if (inputResponse.id.startsWith('protocol-')) {
      this.handleInputUpdateProtocolObj(inputResponse);
    } else {
      if (inputResponse.name.endsWith('-confModal')) {
        this.setState({
          activeComponentConfigName: inputResponse.name,
          activeComponentConfigValue: inputResponse.value,
          isModalAuxBtnDisabled: false
        });
      } else {
        this.setState({
          [inputResponse.name]: inputResponse.value
        });
      }
    }
  };

  handleSwitchChange = (switchName, switchValue) => {

    this.setState({
      [switchName]: switchValue
    })
  };

  handleParamDefValue = () => {
    this.setState({
      activeComponentConfigValue: this.state.activeComponentConfigDefValue,
      isModalAcceptBtnDisabled: false,
      isModalAuxBtnDisabled: true
    })
  }

  handleInputUpdateProtocolObj = (inputResponse) => {
    const inputId = inputResponse.id.replace("protocol-", '');
    const componentProtocolObj = this.state.filteredComponentProtocols.map((componentProtocol) => {
      if (inputId === componentProtocol.id) {
        return {
          ...componentProtocol,
          enabled: !componentProtocol.enabled
        }
      } else return componentProtocol;
    })
    this.setState({
      filteredComponentProtocols: componentProtocolObj
    })
  }

  handleChangeDropdownLoc = (event, setFieldValue, config) => {
    const { formikProps, dropdownName, dropdownIdName, isPersistence } = config;
    let dropdownResponse = handleChangeDropdown(event);

    if (isPersistence) {
      this.handleDropdownUpdatePersistenceObj(
        {
          name: dropdownResponse.name,
          value: dropdownResponse.value,
          childId: dropdownResponse.childId,
          childName: dropdownResponse.childName
        },
        setFieldValue,
        formikProps
      );
    } else {
      setFieldValue(dropdownName, dropdownResponse.childName, true);
      setFieldValue(dropdownIdName, dropdownResponse.childId, true);
      if (formikProps && typeof formikProps.setFieldTouched === "function") {
        formikProps.setFieldTouched(dropdownName, true, true);
      }
    }
  };

  handleDropdownUpdatePersistenceObj = (dropdownData, setFieldValue, formikProps) => {
    const { name, childId, childName } = dropdownData;
    // Asumed that the value for 'name' prop follows 'persistence-index-name' structure
    const [_, index] = name.split('-');

    const updatedValue = {
      ...formikProps.values.componentPersistences[index],
      k8storage: { id: childId, publicname: childName }
    };

    setFieldValue(`componentPersistences[${index}].k8storage`, updatedValue.k8storage);
  };


  toggleAccessSection = (e) => {
    this.setState({
      accordionOpened: !this.state.accordionOpened
    })
  };

  toggleModal = (arg) => {
    let name, id, modal, isSecret;

    // Backdrop/Escape/Exit close comes with an explicit flag: just sync the
    // parent visibility state. The save path (value present) keeps flowing so
    // the existing toggle branch closes the modal exactly once.
    if (typeof arg === 'object' && arg !== null && arg.name && arg.fromModalClose) {
      this.setState({
        [arg.name]: false,
        isModalAuxBtnDisabled: false
      });
      return;
    }

    if (arg && arg.nativeEvent) {
      name = arg.target.name;
      id = arg.target.id;
      modal = arg.target.closest('.modal-dialog');
      isSecret = arg.target.getAttribute('paramtype') === "SECRET";
    } else if (typeof arg === 'object' && arg !== null) {
      name = arg.name;
      id = arg.id;
      modal = document.querySelector(`[name='${arg.name}'] .modal-dialog`);
      isSecret = arg.isSecret;
    } else {
      console.error('Invalid argument passed to toggleModal');
      return;
    }

    if (modal !== null) {
      let modalName = modal.getAttribute('name');
      this.setState(prevState => ({
        [modalName]: !prevState[modalName],
        isModalAuxBtnDisabled: false
      }));
    } else {
      if (isSecret) {
        this.getSecretData(id, name);
      } else {
        this.getConfigData(id, name);
      }
    }
  }


  renderLabels = (formikProps, setFieldValue) => {
    const t = this.props.i18n.t;
    const labelId = formikProps.values && formikProps.values.componentLabelId;
    const labelMissing = !labelId || String(labelId).trim() === "";
    const showError = labelMissing && (formikProps.dirty || formikProps.submitCount > 0);
    const labelClassName = `dropdown-wrapper form-control${showError ? " is-invalid" : ""}`;

    return (
      <>
        <CustomField
          as="select"
          id={'componentlabeldropdown-' + this.state.componentId}
          name="componentLabel"
          className={labelClassName}
          sm="auto"
          showError={false}
          onChange={(e) => this.handleChangeDropdownLoc(e, setFieldValue, {
            formikProps,
            dropdownName: 'componentLabel',
            dropdownIdName: 'componentLabelId'
          })}>
          {this.state.componentLabelId
            ? <option
              name="componentLabelId"
              id={this.state.componentLabelId}
              className="dropdown-option selected">
              {this.state.componentLabelName}
            </option>
            : <option
              className="dropdown-option selected"
              value="">
              {t("platformService.serviceApp.appComponent.labelDropdown.placeholder")}
            </option>
          }
          {this.props.platformLabels.map((defaultLabel) => {
            return (
              this.state.componentLabelId !== defaultLabel.id
                ? <option
                  className="dropdown-option selected"
                  key={defaultLabel.id}
                  id={defaultLabel.id}
                  value={defaultLabel.name}>
                  {defaultLabel.name}
                </option>
                : null
            )
          })}
        </CustomField>
        {showError && (
          <div className="invalid-feedback d-block">{t("platformService.serviceApp.appComponent.labelDropdown.errorMessage")}</div>
        )}
      </>
    );
  }

  getDefaultPlatformStorage = () => {
    const storages = this.props.platformStorages;
    if (!Array.isArray(storages) || storages.length === 0) {
      return null;
    }
    return storages.find((storage) => storage.default) || storages[0];
  };

  renderPersistences = (formikProps, setFieldValue) => {
    const t = this.props.i18n.t;
    const defaultPlatformStorage = this.getDefaultPlatformStorage();

    return this.state.componentPersistences.map((componentPersistence, index) => {
      const componentAtIdx = formikProps.values.componentPersistences && formikProps.values.componentPersistences[index];
      const persistenceStorage = componentAtIdx && componentAtIdx.k8storage && componentAtIdx.k8storage.id
        ? componentAtIdx.k8storage
        : (componentPersistence.k8storage && componentPersistence.k8storage.id
          ? componentPersistence.k8storage
          : defaultPlatformStorage);
      const selectedStorage = persistenceStorage ? persistenceStorage.publicname : '';
      const persistenceSize = componentAtIdx && componentAtIdx.size ? parseInt(componentAtIdx.size, 10) : '';

      return (
        <div className="highlighted-subsection" key={index}>
          <Row>
            <Col sm="12">
              <h6>{componentPersistence.name + ' '}<span className="title-info">{'(' + t("platformService.serviceApp.appComponent.storageSettings.persistenceControl.title") + (index + 1) + ')'}</span></h6>
            </Col>
          </Row>
          <Row>
            <Col sm="6">
              <Row>
                <Col>
                  <Row>
                    <Col sm="8">
                      <Label htmlFor={'persistence-' + componentPersistence.id} sm="auto">{t("platformService.serviceApp.appComponent.storageSettings.persistenceControl.label")}</Label>
                      <CustomField
                        as="select"
                        id={'persistence-' + componentPersistence.id}
                        name={'persistence-' + index + '-' + componentPersistence.name}
                        className="form-control"
                        onChange={(e) => this.handleChangeDropdownLoc(e, setFieldValue, {
                          formikProps: formikProps,
                          isPersistence: true
                        })}
                        value={selectedStorage}>
                        {persistenceStorage && persistenceStorage.id
                          ? <option
                            id={persistenceStorage.id}
                            className="dropdown-option selected"
                            value={persistenceStorage.publicname}>
                            {persistenceStorage.publicname}
                          </option>
                          : <option
                            className="dropdown-option selected"
                            value="">
                            {t("platformService.serviceApp.appComponent.storageSettings.persistenceControl.placeHolder")}
                          </option>
                        }
                        {this.props.platformStorages.map((defaultStorage) => {
                          return (
                            !persistenceStorage || persistenceStorage.id !== defaultStorage.id
                              ? <option
                                id={defaultStorage.id}
                                className="dropdown-option selected"
                                value={defaultStorage.publicname}>
                                {defaultStorage.publicname}
                              </option>
                              : null
                          )
                        })}
                      </CustomField>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col sm="6">
              <Row className="align-items-end">
                <Col sm="8" xl={{ offset: 1 }}>
                  <Label htmlFor={'persistence-' + componentPersistence.id} sm="auto">
                    {t("platformService.serviceApp.appComponent.storageSettings.persistenceControl.persistenceSettings.label")}
                  </Label>
                  <CustomField
                    type="number"
                    id={'persistence-' + componentPersistence.id}
                    name={'persistence-' + index + '-' + componentPersistence.name + '-size'}
                    className="custom-range form-control"
                    value={persistenceSize}
                    min="1"
                    disabled={this.props.appDeployCode != null && this.props.appDeployCode !== BackEndConsts.DEPLOYMENT_STATE_NEVERDEPLOYED}
                    onChange={(e) => { this.handleInputChangeLoc(e, setFieldValue) }}
                    placeholder={t("platformService.serviceApp.appComponent.storageSettings.persistenceControl.persistenceSettings.placeHolder")} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      );
    });
  }

  renderProtocols = (formikProps) => {
    const t = this.props.i18n.t;
    const checkboxes = this.state.componentProtocols.map(componentProtocol => (
      <div
        key={componentProtocol.id}
        className="custom-checkbox custom-control custom-control-inline">
        <CustomField
          type="checkbox"
          id={'protocol-' + componentProtocol.id}
          name="enabledProtocols"
          className="custom-control-input"
          value={componentProtocol.id}
          checked={formikProps.values.enabledProtocols.includes(componentProtocol.id)}
          onChange={this.handleInputChangeLoc}
          disabled={formikProps.values.loadbalancerSwitch ? false : true}
          showError={false}//To NOT show the error message per EACH checkbox
        />
        <label
          htmlFor={'protocol-' + componentProtocol.id}
          className="custom-control-label">{componentProtocol.name}</label>
      </div>
    ));

    // Verify if there's a validation error and show it just ONCE after all checkboxes
    const isError = formikProps.errors['enabledProtocols'] && formikProps.touched['enabledProtocols'];
    const errorMessage = isError
      ? <div className="invalid-feedback d-block">{t("platformService.serviceApp.appComponent.resourceSettings.protocolCheckbox.requiredMessage")}</div>
      : null;

    return (
      <>
        {checkboxes}
        {errorMessage}
      </>
    );
  }

  renderConfigurations = () => {
    const t = this.props.i18n.t;

    return (
      this.state.componentConfigMergedArray.map((componentConfig) => {
        return (
          <>
            <div className="component-config-wrapper">
              <i name={'component-config-' + componentConfig.id}
                className="icon-conf" />
              <Button
                name={componentConfig.publicname + '-confModal'}
                id={componentConfig.id}
                className="info-wrapper elem-submit-btn settings-conf-elem"
                paramtype={componentConfig.configtype}
                onClick={(e) => { this.toggleModal(e) }}>
                {componentConfig.publicname}
              </Button>
            </div>
            {this.state[componentConfig.publicname + '-confModal']
              ? <FormModal
                lang={this.props.i18n.language}
                id={this.state.activeComponentConfigId}
                name={this.state.activeComponentConfigName}
                label={this.state.activeComponentConfigLabel}
                value={this.state.activeComponentConfigValue}
                defValue={this.state.activeComponentConfigDefValue}
                toggleModal={(e) => { this.toggleModal(e) }}
                acceptOnClick={(e) => {
                  this.state.activeComponentConfigModalType === "SECRET"
                    ? this.updateComponentSecretData(e)
                    : this.updateComponentConfigData(e)
                }}
                handleInputChange={(e) => { this.handleInputChangeLoc(e) }}
                auxBtnFunction={() => { this.handleParamDefValue() }}
                modalType={this.state.activeComponentConfigModalType}
                modalFormat={this.state.activeComponentConfigModalFormat}
                modalTitleIcon={'icon-conf'}
                modalTitleText={t("platformService.serviceApp.appComponent.configurationSettings.formTitle")}
                modalBodyText={this.state.activeComponentConfigBodyText}
                modalShowAuxBtn={this.state.activeComponentConfigShowAuxBtn}
                acceptBtnDisabled={this.state.isModalAcceptBtnDisabled}
                auxBtnDisabled={this.state.isModalAuxBtnDisabled}
                modalAcceptBtn={this.state.activeComponentConfigAcceptBtn}
                modalCancelBtn={this.state.activeComponentConfigCancelBtn}
                modalAuxBtn={this.state.activeComponentConfigAuxBtn} />
              : null
            }
          </>
        )
      })
    )
  }

  createDynamicYupSchema = () => {
    const { t } = this.props.i18n;

    const persistenceSchema = Yup.object().shape({
      size: Yup.string()
        .required(t("platformService.serviceApp.appComponent.resourceSettings.persistence.inputControl.requiredMessage"))
        .transform(value => (typeof value === 'number' || (typeof value === 'string' && value.match(/^\d+$/))) ? `${value}Gi` : value)
        .matches(/^\d+Gi$/, t("platformService.serviceApp.appComponent.persistence.inputControl.errorNotANumber")),
      k8storage: Yup.object().shape({
        publicname: Yup.string()
          .required(t("platformService.serviceApp.appComponent.resourceSettings.persistence.dropdown.requiredMessage")),
      })
    });

    let schemaFields = {};

    schemaFields.componentLabel = Yup.string()
      .required(t("platformService.serviceApp.appComponent.labelDropdown.errorMessage"));

    if (this.state.showLoadBalancer && this.state.componentProtocolId !== null) {
      schemaFields.enabledProtocols = Yup.array()
        .min(1, t("platformService.serviceApp.appComponent.resourceSettings.protocolCheckbox.requiredMessage"));
    }

    if (this.state.showComponentPods === true) {
      schemaFields.componentPods = Yup.number()
        .typeError(t("platformService.serviceApp.appComponent.resourceSettings.numberPodsControl.errorMessage"))
        .required(t("platformService.serviceApp.appComponent.resourceSettings.numberPodsControl.errorMessage"))
        .min(this.state.componentMinimumPods, t("platformService.serviceApp.appComponent.resourceSettings.numberPodsControl.requiredMessage", { minimumPods: this.state.componentMinimumPods }))
        .test(
          'is-odd',
          t("platformService.serviceApp.appComponent.resourceSettings.numberPodsControl.errorPodQuorum"),
          (value) => {
            if (this.state.componentQuorumPods) {
              return value % 2 !== 0;  // Must be odd (1, 3, 5...)
            }
            return true;
          }
        );
    }


    if (this.state.showResourceParams === true) {
      schemaFields = {
        ...schemaFields,
        componentCPU: Yup.number()
          .typeError(t("platformService.serviceApp.appComponent.resourceSettings.cpuRequest.errorMessage"))
          .min(0, t("platformService.serviceApp.appComponent.resourceSettings.cpuRequest.errorMessage"))
          .test('cpu-limit', t("platformService.serviceApp.appComponent.resourceSettings.cpuRequest.errorLimitMessage"), function (value) {
            const limit = this.parent.componentCPULimit;
            // Skip the cross-field check when either value is not a valid number;
            // each field's own typeError already reports the problem.
            if (typeof value !== 'number' || isNaN(value)) return true;
            if (typeof limit !== 'number' || isNaN(limit)) return true;
            return value <= limit;
          }),
        componentMem: Yup.number()
          .typeError(t("platformService.serviceApp.appComponent.resourceSettings.memRequest.errorMessage"))
          .min(0, t("platformService.serviceApp.appComponent.resourceSettings.memRequest.errorMessage"))
          .test('mem-limit', t("platformService.serviceApp.appComponent.resourceSettings.memRequest.errorLimitMessage"), function (value) {
            const limit = this.parent.componentMemLimit;
            if (typeof value !== 'number' || isNaN(value)) return true;
            if (typeof limit !== 'number' || isNaN(limit)) return true;
            return value <= limit;
          }),
        componentCPULimit: Yup.number()
          .typeError(t("platformService.serviceApp.appComponent.resourceSettings.cpuLimit.errorMessage"))
          .min(0, t("platformService.serviceApp.appComponent.resourceSettings.cpuLimit.errorMessage"))
          .test('cpu-limit-min', t("platformService.serviceApp.appComponent.resourceSettings.cpuLimit.errorRequestMessage"), function (value) {
            const request = this.parent.componentCPU;
            if (typeof value !== 'number' || isNaN(value)) return true;
            if (typeof request !== 'number' || isNaN(request)) return true;
            return value >= request;
          }),
        componentMemLimit: Yup.number()
          .typeError(t("platformService.serviceApp.appComponent.resourceSettings.memLimit.errorMessage"))
          .min(0, t("platformService.serviceApp.appComponent.resourceSettings.memLimit.errorMessage"))
          .test('mem-limit-min', t("platformService.serviceApp.appComponent.resourceSettings.memLimit.errorRequestMessage"), function (value) {
            const request = this.parent.componentMem;
            if (typeof value !== 'number' || isNaN(value)) return true;
            if (typeof request !== 'number' || isNaN(request)) return true;
            return value >= request;
          })
      };
    }

    return Yup.object().shape(schemaFields);
  }

  render() {
    const { t } = this.props.i18n;
    const validationSchema = this.createDynamicYupSchema();

    return (
      <>
        <Col sm="12" className="component-wrapper">
          <Formik
            enableReinitialize={true}
            initialValues={{
              componentPods: this.state.componentPods,
              componentCPU: this.state.componentCPU,
              componentCPULimit: this.state.componentCPULimit,
              componentMem: this.state.componentMem,
              componentMemLimit: this.state.componentMemLimit,
              componentLabel: this.state.componentLabelName,
              componentLabelId: this.state.componentLabelId,
              enabledProtocols: this.state.componentEnabledProtocols,
              loadbalancerSwitch: this.state.loadbalancer,
              componentPersistences: this.state.componentPersistences
            }}
            validationSchema={validationSchema}
            onSubmit={(values, formikHelpers) => {
              this.updateData(values, formikHelpers);
            }}
          >
            {(formikProps) => {
              const { setFieldValue, setFieldTouched, dirty, values, isValid } = formikProps;
              const resourceRequestMin = 0;
              const resourceLimitMax = 16000;
              const cpuLimitMin = values.componentCPU;
              const memLimitMin = values.componentMem;
              const touchCpuResourceFields = () => {
                setFieldTouched('componentCPU', true, true);
                setFieldTouched('componentCPULimit', true, true);
              };
              const touchMemResourceFields = () => {
                setFieldTouched('componentMem', true, true);
                setFieldTouched('componentMemLimit', true, true);
              };
              const clampPercent = (value, min, max) => {
                if (max < min) return 100;
                if (max === min) return value >= max ? 100 : 0;
                const pct = ((value - min) / (max - min)) * 100;
                return Math.min(100, Math.max(0, pct));
              };
              const cpuRequestPercent = clampPercent(
                values.componentCPU,
                resourceRequestMin,
                values.componentCPULimit
              );
              const memRequestPercent = clampPercent(
                values.componentMem,
                resourceRequestMin,
                values.componentMemLimit
              );
              const cpuLimitPercent = clampPercent(
                values.componentCPULimit,
                cpuLimitMin,
                resourceLimitMax
              );
              const memLimitPercent = clampPercent(
                values.componentMemLimit,
                memLimitMin,
                resourceLimitMax
              );
              this.currentFormikValues = values; // Capture values for external updates
              this.currentFormikProps = formikProps;

              // Monitor dirty state: form fields OR config/secret modal edits.
              // Deployed apps compare against server baseline; Formik `dirty` alone is unreliable.
              const hasConfigOrSecretChanges = this.hasDirtyConfigOrSecretChanges();
              const formHasChanges = this.props.appActivation === true
                ? this.hasFormValueChanges(values)
                : dirty;
              const combinedDirty = formHasChanges || hasConfigOrSecretChanges;
              const valuesStr = JSON.stringify(values);
              const pendingConfigStr = JSON.stringify(
                (this.state.componentConfiguration || [])
                  .map(c => ({ id: c.id, value: c.value }))
              );
              const pendingSecretStr = JSON.stringify(
                (this.state.componentSecrets || [])
                  .map(s => ({ id: s.id, value: s.value }))
              );
              const dirtySignature = `${valuesStr}|${pendingConfigStr}|${pendingSecretStr}`;
              const dirtyStateChanged = combinedDirty !== this.state.isDirty;
              const dirtyPayloadChanged = combinedDirty && dirtySignature !== this.lastNotifiedValuesStr;
              const shouldClearParentDirty = !combinedDirty && this.lastNotifiedParentDirty === true;

              if (dirtyStateChanged || dirtyPayloadChanged || shouldClearParentDirty) {
                // Use setTimeout to avoid updating state during render
                if (this.dirtyCheckTimeout) clearTimeout(this.dirtyCheckTimeout);
                this.dirtyCheckTimeout = setTimeout(() => {
                  const syncedFlags = this.syncConfigSecretDirtyFlags();
                  const statePatch = { isDirty: combinedDirty, ...syncedFlags };

                  if (dirtyStateChanged || shouldClearParentDirty) {
                    this.setState(statePatch);
                  } else if (
                    syncedFlags.componentConfiguration !== this.state.componentConfiguration
                    || syncedFlags.componentSecrets !== this.state.componentSecrets
                  ) {
                    this.setState(syncedFlags);
                  }

                  this.lastNotifiedValuesStr = dirtySignature;
                  this.lastNotifiedParentDirty = combinedDirty;
                  // Recompute validity synchronously from the current values.
                  // Formik's `isValid` lags one render behind `values` (validation
                  // runs async on change), so relying on it here can persist a stale
                  // "invalid" state that blocks batch saves even when the form is fine.
                  const { isValid: currentIsValid, errors: validationErrors } = this.computeValidation(values);
                  if (currentIsValid === false) {
                    debugLog("dirty", "invalid fields for", this.state.componentName, validationErrors);
                  }
                  this.notifyDirtyStateChange(combinedDirty, values, currentIsValid, validationErrors);
                }, 0);
              }

              return (
                <Form>
                  <div className={`settings-section sub-section app-component ${this.state.accordionOpened ? "expanded" : ""} ${this.state.isDirty ? "dirty" : ""}`}>
                    <Row
                      className="sub-section-header"
                      id={'component-' + this.state.componentId}
                      onClick={(e) => {
                        this.toggleAccessSection(e)
                      }}
                    >
                      <Col sm="6" className={`sub-section-title ${this.state.accordionOpened ? "expanded" : ""}`}>
                        <i className="icon-cube"></i>
                        <span className="software-version">{t("platformService.serviceApp.appComponent.componentVersion", { componentVersion: this.state.componentVersion })}</span>
                        <h4>
                          {this.state.componentName}
                          {this.state.isDirty && <span className="dirty-indicator" title={t("common.unsavedChanges")} />}
                        </h4>
                      </Col>
                      <Col sm="6" className="sub-section-btn">
                        <i className={`elem-settings-btn ${this.state.accordionOpened ? "icon-up-pike expanded" : "icon-down-pike"}`}></i>
                      </Col>
                    </Row >
                    <Collapse
                      isOpen={this.state.accordionOpened}
                      className="sub-section-body">
                      {this.props.interactionBlocked === true && (
                        <div
                          className="interaction-blocker"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (this.props.onBlockedInteraction) this.props.onBlockedInteraction();
                          }}
                        />
                      )}
                      <Row>
                        <Col sm="12">
                          <div className="settings-section highlighted-section sub-section app-component">
                            <section className="highlighted-sub-section">
                              <h5>{t("platformService.serviceApp.appComponent.resourceSettings.title")}</h5>
                              {this.state.showLoadBalancer === true &&
                                this.state.componentProtocolId !== null &&
                                <Row className="component-row">
                                  <Col sm="6">
                                    <div className="settings-wrapper">
                                      <Row>
                                        <Col sm="12">
                                          <div className="custom-radio-button-wrapper form-group">
                                            <legend>{t("platformService.serviceApp.appComponent.resourceSettings.protocolCheckbox.label")}</legend>
                                            {this.renderProtocols(formikProps)}
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col sm="6">
                                    <div className="settings-wrapper">
                                      <Row>
                                        <Col sm="8" xl={{ offset: 1 }}>
                                          <Label htmlFor={'loadbalancerswitch-' + this.state.componentId} sm="auto">
                                            {t("platformService.serviceApp.appComponent.resourceSettings.loadBalancerControl.label")}
                                          </Label>
                                          <CustomField
                                            shape="switch"
                                            id={'loadbalancerswitch-' + this.state.componentId}
                                            name="loadbalancerSwitch"
                                            component={LainoSwitch}
                                            disabled={this.state.appState === "UPDATING" ? true : false}
                                            disableStyles={this.state.appState !== "UPDATING" ? "" : "disabled disabled"}
                                            hexColor={this.props.hexColor} />
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                              }
                              <Row className="component-row">
                                {this.state.showComponentPods === true &&
                                  <Col sm="6">
                                    <div className="settings-wrapper">
                                      <Row>
                                        <Col sm="8">
                                          <Label htmlFor={'componentpods-' + this.state.componentId} sm="auto">
                                            {t("platformService.serviceApp.appComponent.resourceSettings.numberPodsControl.label")}
                                          </Label>
                                          <CustomField
                                            type="number"
                                            id={'componentpods-' + this.state.componentId}
                                            name="componentPods"
                                            className="custom-range form-control"
                                            sm="auto"
                                            min={this.state.componentMinimumPods}
                                            placeholder={t("platformService.serviceApp.appComponent.resourceSettings.numberPodsControl.placeHolder")} />
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                }
                                <Col sm="6">
                                  <div className="settings-wrapper">
                                    <Row>
                                      <Col sm="8" xl={this.state.showComponentPods === true ? { offset: 1 } : "8"}>
                                        <Label htmlFor={'componentlabeldropdown-' + this.state.componentId} sm="auto">{t("platformService.serviceApp.appComponent.labelDropdown.title")}</Label>
                                        {this.renderLabels(formikProps, setFieldValue)}
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                              {this.state.showResourceParams &&
                                <>
                                  <Row className="component-row">
                                    <Col sm="6">
                                      <div className="settings-wrapper">
                                        <Row>
                                          <Col sm="8">
                                            <Label htmlFor={'componentcpurangebar-' + this.state.componentId} sm="auto">
                                              {t("platformService.serviceApp.appComponent.resourceSettings.cpuRequest.label")}
                                            </Label>
                                            <div
                                              className="range-visual-wrapper"
                                              style={{ '--range-percent': `${cpuRequestPercent}%` }}>
                                              <div className="range-visual-bar" aria-hidden="true">
                                                <div className="range-visual-track" />
                                                <div className="range-visual-fill" />
                                                <div className="range-visual-thumb" />
                                              </div>
                                              <CustomField
                                                as="input"
                                                id={'componentcpurangebar-' + this.state.componentId}
                                                name="componentCPU"
                                                type="range"
                                                className="custom-range form-control-range range-input"
                                                sm="auto"
                                                min={resourceRequestMin}
                                                max={values.componentCPULimit}
                                                step={10}
                                                onChange={touchCpuResourceFields} />
                                            </div>
                                          </Col>
                                          <Col xs="2" sm="4" xl="3">
                                            <CustomField
                                              type="text"
                                              name="componentCPU"
                                              className="range-textbox form-control"
                                              sm="auto"
                                              placeholder={t("platformService.serviceApp.appComponent.resourceSettings.cpuRequest.placeHolder")}
                                              min={resourceRequestMin}
                                              max={values.componentCPULimit}
                                              showError={false}
                                              onChange={touchCpuResourceFields} />
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                    <Col sm="6">
                                      <div className="settings-wrapper">
                                        <Row>
                                          <Col sm="8" xl={{ offset: 1 }}>
                                            <Label htmlFor={'componentmemrangebar-' + this.state.componentId} sm="auto">
                                              {t("platformService.serviceApp.appComponent.resourceSettings.memRequest.label")}
                                            </Label>
                                            <div
                                              className="range-visual-wrapper"
                                              style={{ '--range-percent': `${memRequestPercent}%` }}>
                                              <div className="range-visual-bar" aria-hidden="true">
                                                <div className="range-visual-track" />
                                                <div className="range-visual-fill" />
                                                <div className="range-visual-thumb" />
                                              </div>
                                              <CustomField
                                                as="input"
                                                type="range"
                                                id={'componentmemrangebar-' + this.state.componentId}
                                                name="componentMem"
                                                className="custom-range form-control-range range-input"
                                                min={resourceRequestMin}
                                                max={values.componentMemLimit}
                                                step={10}
                                                sm="auto"
                                                onChange={touchMemResourceFields} />
                                            </div>
                                          </Col>
                                          <Col xs="2" sm="4" xl="3">
                                            <CustomField
                                              type="text"
                                              name="componentMem"
                                              className="range-textbox form-control"
                                              sm="auto"
                                              placeholder={t("platformService.serviceApp.appComponent.resourceSettings.memRequest.placeHolder")}
                                              min={resourceRequestMin}
                                              max={values.componentMemLimit}
                                              showError={false}
                                              onChange={touchMemResourceFields} />
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="component-row">
                                    <Col sm="6">
                                      <div className="settings-wrapper">
                                        <Row>
                                          <Col sm="8">
                                            <Label htmlFor={'componentcpulimitrangebar-' + this.state.componentId} sm="auto">
                                              {t("platformService.serviceApp.appComponent.resourceSettings.cpuLimit.label")}
                                            </Label>
                                            <div
                                              className="range-visual-wrapper"
                                              style={{ '--range-percent': `${cpuLimitPercent}%` }}>
                                              <div className="range-visual-bar" aria-hidden="true">
                                                <div className="range-visual-track" />
                                                <div className="range-visual-fill" />
                                                <div className="range-visual-thumb" />
                                              </div>
                                              <CustomField
                                                as="input"
                                                type="range"
                                                id={'componentcpulimitrangebar-' + this.state.componentId}
                                                name="componentCPULimit"
                                                className="custom-range form-control-range range-input"
                                                min={cpuLimitMin}
                                                max={resourceLimitMax}
                                                step={10}
                                                sm="auto"
                                                onChange={touchCpuResourceFields} />
                                            </div>
                                          </Col>
                                          <Col xs="2" sm="4" xl="3">
                                            <CustomField
                                              type="text"
                                              name="componentCPULimit"
                                              className="range-textbox form-control"
                                              placeholder={t("platformService.serviceApp.appComponent.resourceSettings.cpuLimit.placeHolder")}
                                              min={cpuLimitMin}
                                              max={resourceLimitMax}
                                              sm="auto"
                                              showError={false}
                                              onChange={touchCpuResourceFields} />
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                    <Col sm="6">
                                      <div className="settings-wrapper">
                                        <Row>
                                          <Col sm="8" xl={{ offset: 1 }}>
                                            <Label htmlFor={'componentmemlimitrangebar-' + this.state.componentId} sm="auto">
                                              {t("platformService.serviceApp.appComponent.resourceSettings.memLimit.label")}
                                            </Label>
                                            <div
                                              className="range-visual-wrapper"
                                              style={{ '--range-percent': `${memLimitPercent}%` }}>
                                              <div className="range-visual-bar" aria-hidden="true">
                                                <div className="range-visual-track" />
                                                <div className="range-visual-fill" />
                                                <div className="range-visual-thumb" />
                                              </div>
                                              <CustomField
                                                as="input"
                                                type="range"
                                                id={'componentmemlimitrangebar-' + this.state.componentId}
                                                name="componentMemLimit"
                                                className="custom-range form-control-range range-input"
                                                sm="auto"
                                                min={memLimitMin}
                                                max={resourceLimitMax}
                                                step={10}
                                                onChange={touchMemResourceFields} />
                                            </div>
                                          </Col>
                                          <Col xs="2" sm="4" xl="3">
                                            <CustomField
                                              type="text"
                                              name="componentMemLimit"
                                              className="range-textbox form-control"
                                              sm="auto"
                                              placeholder={t("platformService.serviceApp.appComponent.resourceSettings.memLimit.placeHolder")}
                                              min={memLimitMin}
                                              max={resourceLimitMax}
                                              showError={false}
                                              onChange={touchMemResourceFields} />
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              }
                            </section>
                            {this.state.componentConfigMergedArray &&
                              this.state.componentConfigMergedArray.length !== 0 &&
                              <section className="highlighted-sub-section">
                                <Row>
                                  <Col sm="12">
                                    <h5>{t("platformService.serviceApp.appComponent.configurationSettings.title")}</h5>
                                    <ul className="settings-conf-list">
                                      {this.renderConfigurations()}
                                    </ul>
                                  </Col>
                                </Row>
                              </section>
                            }
                            {this.state.componentPersistences !== null &&
                              this.state.componentPersistences.length > 0 &&
                              <section className="highlighted-sub-section">
                                <h5>{t("platformService.serviceApp.appComponent.storageSettings.title")}</h5>
                                {this.renderPersistences(formikProps, setFieldValue)}
                              </section>
                            }
                            {this.props.appActivation !== true && this.state.isDirty && (
                              <section className="highlighted-sub-section">
                                <div className="section-submit-wrapper app-component-actions">
                                  <Button
                                    color="secondary"
                                    type="button"
                                    onClick={() => {
                                      this.handleDiscard(formikProps.resetForm);
                                    }}
                                  >
                                    {t("platformService.serviceApp.batchSaveModal.discard")}
                                  </Button>
                                  <Button
                                    color={this.context || "primary"}
                                    disabled={!this.state.isDirty || !formikProps.isValid}
                                    type="submit">{t("common.save")}</Button>
                                </div>
                              </section>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Collapse>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </>
    );
  }
}

export default AppComponent;

AppComponent.propTypes = {
  appcomponentprotocols: PropTypes.array,
  batchValidationCounter: PropTypes.number
}
